import React from 'react'
import { useValues } from 'kea'

import FullScreen from 'lib/components/full-screen'
import getDeviceType from 'lib/utils/get-device-type'

import Filters from './filters'

import filtersLogic from '~/scenes/search/filters-page/logic'

export default function FiltersPage () {
  const { activeSubMenu } = useValues(filtersLogic)
  const { name: deviceName } = getDeviceType() && getDeviceType().os
  const { name: browserName } = getDeviceType() && getDeviceType().client
  const isLocationFilterActive = activeSubMenu === 'location'
  const isIos = deviceName !== undefined && deviceName === 'iOS'
  const isMobileSafari = browserName !== undefined && browserName === 'Mobile Safari'

  return (
    <div className='search-page with-mobile-header no-top-padding'>
      <div
        className={`filter-fullscreen-mode${
          isLocationFilterActive && isIos && isMobileSafari ? ' expand-options' : ''
        }`}
        id='main-all-filter'
      >
        <FullScreen />
        <Filters fullScreenFiltersPage />
      </div>
    </div>
  )
}
